module.exports = __webpack_public_path__ + "img/projects.8eeb133e.svg";